export default __webpack_public_path__ + "static/media/deleteIcon.83d3db57.svg";